import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalService, ModalData } from '../../../services/modal.service';
import { Subscription } from 'rxjs';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css']
})
export class ModalComponent implements OnInit, OnDestroy {
  modalData: ModalData | null = null;
  private subscription: Subscription | undefined;
  selectedStatus: string | undefined;

  constructor(private modalService: ModalService) {}

  ngOnInit(): void {
    this.subscription = this.modalService.modalState$.subscribe(data => {
      this.modalData = data;
      if (data?.statusOptions?.length) {
        this.selectedStatus = data.initialStatus || data.statusOptions[0];
      } else {
        this.selectedStatus = undefined;
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  close(): void {
    this.modalService.close();
  }

  confirm(decision: boolean): void {
    if (decision && this.selectedStatus !== undefined) {
      this.modalService.confirm(this.selectedStatus);
    } else {
      this.modalService.confirm(decision);
    }
  }
}
